import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { titleHandler } from './Helpers/helpers';

import {
  AppBar,
  Box,
  Button,
  createTheme,
  CssBaseline,
  IconButton,
  ThemeProvider,
  Toolbar,
  Typography,
  useMediaQuery,
} from '@mui/material';

import { GridMenuIcon } from '@mui/x-data-grid';
import Drawer from '@mui/material/Drawer';
import MainNavBar from './Design/Navigation';
import { Outlet } from 'react-router-dom';
import { themeOptions } from './Design/theme';
import { GetAuth } from './Auth/AuthProvider';

const width = 240; //Width of drawer
const theme = createTheme(themeOptions); //Configure global theme - not currently fully implemented

export default function MainScreen(props) {
  const [pageTitle, setPageTitle] = useState('Ticket Control');

  const auth = GetAuth();
  const { window } = props; //Get window data to configure Drawer
  const [mobileActive, setMobileActive] = useState(false); //Bool - drawer open or close in mobile view
  const toggleOpen = () => {
    //Function to toggle between open and closed states in mobile view
    setMobileActive(!mobileActive);
  };
  const container =
    window !== undefined ? () => window().document.body : undefined; //Checks container from window - used to configure Drawer
  const mobileSize = !useMediaQuery('(min-width: 900px)'); //If true then on mobile view

  const location = useLocation();

  return (
    <>
      <ThemeProvider theme={theme}>
        <Box
          sx={{
            display: 'flex',
          }}
        >
          <CssBaseline />
          <AppBar
            position='fixed'
            sx={{
              width: { md: `calc(100% - ${width}px)` },
              ml: { md: `${width}px` },
              height: { xs: 40, md: 100 },
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Toolbar>
              <IconButton
                color='inherit'
                edge='start'
                onClick={toggleOpen}
                sx={{ mr: 2, display: { md: 'none' } }}
              >
                <GridMenuIcon />
              </IconButton>
              <Typography
                variant='h5'
                noWrap
                // component='div'
                sx={{
                  fontSize: '1.5em',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexGrow: 1,
                  textAlign: 'center',
                }}
              >
                {titleHandler(location.pathname)}
              </Typography>
              <Button
                color='inherit'
                onClick={() => {
                  auth.signOut();
                }}
              >
                Logout
              </Button>
            </Toolbar>
          </AppBar>
          <Box
            component='nav'
            sx={{ width: { md: width }, flexShrink: { md: 0 } }}
          >
            <Drawer
              container={mobileSize ? container : undefined}
              variant={mobileSize ? 'temporary' : 'permanent'}
              open={mobileSize ? mobileActive : true}
              onClose={mobileSize ? toggleOpen : undefined}
              onClick={mobileSize ? toggleOpen : undefined}
              PaperProps={{
                sx: {
                  color: 'white',
                  backgroundColor: '#354775',
                  boxSizing: 'border-box',
                  width: width,
                },
              }}
              sx={
                mobileSize
                  ? { display: { sm: 'block', md: 'none' } }
                  : { display: { sm: 'none', md: 'block' } }
              }
            >
              <MainNavBar toggle={toggleOpen} />
            </Drawer>
          </Box>
          <Box
            component='main'
            sx={{
              flexGrow: 1,
              p: 13,
              width: { md: `calc(100% - ${width}px)` },
              padding: '50px 10px 10px 10px',
            }}
          >
            <Toolbar />
            <Outlet />
          </Box>
        </Box>
      </ThemeProvider>
    </>
  );
}
